import type { FilterSeparator } from '@sorare/core/src/lib/filters';

export const filterSeparator: FilterSeparator = { type: 'separator' };
export {
  RefineActiveNationalTeam,
  RefineActiveLeague,
  RefineCardEdition,
  RefinePlayer,
  RefineSeason,
  RefineSingleYearSeason,
  RefinePlayingStatus,
  RefineNationality,
  RefineBirthplace,
} from './RefineList';
export { RefineCardPlayerAge } from './RefineAge';
export { RefineCardLevel } from './RangeSlider';
export { RefineAverageScore } from './RefineAverageScore';
export { RefineAppearances } from './RefineAppearances';
export { RefineSerialNumber } from './RefineSerialNumber';
export { widget as RefineCompetitionEligibility } from './RefineCompetitionEligibility';

export { widget as NotInLineupFilter } from './NotInLineupFilter';
export { widget as CollectibleFilter } from './CollectibleFilter';
export { GameweekFilter, DailyFilter } from './FixtureFilter';
export { widget as RefineOnSale } from './RefineOnSale';
export { widget as RefineCreditEligible } from './RefineCreditEligible';
export { AdvancedCardSearch } from './AdvancedCardSearch';
export {
  widget as PromotionalEventFilter,
  PromotionalEventFilterForInstantBuy,
} from './PromotionalEventFilter';
export { widget as RefineInSeason } from './RefineInSeason';
export {
  AcceptedCurrencyGroup,
  CollectibleGroup,
  PriceGroup,
  RarityGroup,
  SaleGroup,
} from './refineGroups';
export { RefinePosition, RefineBackendPosition } from './RefinePosition';
export { widget as BidToEarnFilter } from './BidToEarnFilter';
export { RevealableCardCampaignMenu } from './RevealableCardCampaignMenu';
